if (!customElements.get("mystery-gift")) {
  customElements.define(
    "mystery-gift",
    class MysteryGift extends HTMLElement {
      static #hasPrimary = false;
      #isPrimary = false;
      #fetchCart;
      #cartData;
      #existProduct;
      #dialogWrap;
      #nodes;
      #wrapper;
      #scrollTimeout;
      #mysteryTimeout;
      constructor() {
        super();
        this.#nodes = this.querySelectorAll(".mystery-gift__node");
        // 只让第一个注册为主组件
        if (!MysteryGift.#hasPrimary) {
          MysteryGift.#hasPrimary = true;
          this.#isPrimary = true;
        }
      }

      async connectedCallback() {
        if (!this.#isPrimary) return;
        document.addEventListener("cart:change", (event) => {
          console.log(event.detail.cart.items,8888)
          clearTimeout(this.#mysteryTimeout);
          this.#mysteryTimeout = setTimeout(() => {
            this.mysteryGift()
          }, 1300);
          this.#fetchCart = event.detail["cart"];
          this.refreshCartData();
        });
        window.addEventListener("pageshow", (event) => {
          setTimeout(() => {
            this.mysteryGift()
          }, 1000);
          // if (window.themeVariables.settings.pageType == "cart") {
          //   setTimeout(() => {
          //     this.mysteryGift()
          //   }, 1000);
          // }
        });
      }
      mysteryGift() {
        const list = Array.from(document.querySelectorAll(".new-cart-drawer .cart-drawer__line-item-mystery")).map(item => {
          return {
            price: item.getAttribute("data-price"),
            id: item.getAttribute("data-product-id"),       // base product line item id
            handle: item.getAttribute("data-product-handle"), // base product handle
            giftId: item.getAttribute("data-mystery-id"),    // gift line item id
            giftHandle: item.getAttribute("data-mystery-handle"), // gift handle
            type: item.getAttribute("data-type"),
            href: item.getAttribute("data-href")
          };
        });
        console.log(list,999)
        const cartIds = list.map(item => item.id);

        // Remove gifts if their base product is gone
        const giftIds = list.filter(item => item.type === "Gift Card");
        giftIds.forEach(v => {
          if(!list.find(item => item.giftId === v.id)) {
            console.log(`Removing gift with id ${v.id}`);
            const url = new URL(v.href, 'https://aa.host');
            fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: url.searchParams.get("id"),
                quantity: 0
              })
            })
            .then(response => response.json())
            .then(data => {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              const gift = document.querySelector(`.id-${v.id}`);
              if(gift) {
                gift.remove();
              }
            })
            .catch(error => {
              console.error('Error removing item from cart:', error);
            });
          }
        })

        // Add gifts if not already in cart
        list.forEach(product => {
          if (product.giftHandle) {
            const giftInCart = list.find(ci => ci.id === product.giftId);
            if (!giftInCart && cartIds.includes(product.id)) {
              Apex.queryProduct(product.giftHandle).then(giftProduct => {
                if (giftProduct?.variants?.length > 0) {
                  const variant = giftProduct.variants[0];
                  Apex.addProduct([{ id: variant.id, quantity: 1 }]).then(() => {
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                  });
                }
              });
            }
          }
        });
      }
    }
  );
}
